import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import type { INestedRule } from '@/classes/rules/INestedRule';
import { createRuleHelper } from '@/helpers/rulesHelper';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import scenarioRules from '@/helpers/rulesModules/scenarioRules';
import { ProjectMeta } from '@/classes/ProjectMeta';
import { Specifications } from '@/services/ruleService';

interface Dependencies {
  loadFile: <ReturnedType>(filename: string) => Promise<{data: ReturnedType}>;
  assignSpecificationsToRules: (specifications: any, rules: INestedRule) => void;
  assignCountryReferences: (countryRef: string, rules: INestedRule) => void;
  rulesGenerator: () => Promise<INestedRule>;
}

export const buildRuleModule = ({ loadFile, assignSpecificationsToRules, assignCountryReferences, rulesGenerator }: Dependencies) => {
  @Module({
    namespaced: true
  })
  class RulesModule extends VuexModule {
    rules = scenarioRules;

    @Action({ rawError: true })
    async updateRules({ typeRef, country3Ref }: ProjectMeta) {
      const { data: specifications } = await loadFile<Specifications>(`${typeRef}_specifications`) ?? {};
      this.context.commit('resetRules', await rulesGenerator());
      assignSpecificationsToRules(specifications.scenario, this.rules);
      if (country3Ref) {
        assignCountryReferences(country3Ref, this.rules);
      }
    }

    @Mutation
    resetRules(newRootRule: INestedRule) {
      // TODO this is a terrible hack to compensate the global variable scenarioRule that needs to be removed
      (this.rules as any).rules = (newRootRule as any).rules;
    }

    get defaultScenario() {
      return () => {
        const defaultScenario = createRuleHelper({ rules: this.rules }).getDefaultScenario();
        return new ScenarioExt({ ...defaultScenario, name: 'New scenario' });
      };
    }

    get rule() {
      return (path: string[]) => {
        const ruleHelper = createRuleHelper({ rules: this.rules });
        return ruleHelper.getFromRulesDictionary(path);
      };
    }
  }

  return RulesModule;
};
